module.exports = __webpack_public_path__ + "img/elpost.02a17135.png";